import apiCommonCategory from "@/api/common-category";

export default class apiBkCompanyType extends apiCommonCategory{
  static module="bk_company_type";
}
